////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import React, {CSSProperties, ReactNode} from 'react';
import {Flyout} from "@adsk/alloy-react-tooltip";
import Theme from "@adsk/alloy-react-theme";
import {LinkButton} from "@adsk/alloy-react-button";
import {AlertWarningIcon} from "@adsk/alloy-react-icon";

const WarningPopover = ({pageSize, content, flyoutPlacement, style, onLoadAll}: {
  pageSize?: number,
  content?: ReactNode,
  flyoutPlacement?: 'top' | 'bottom' | 'left' | 'right',
  style?: CSSProperties,
  onLoadAll?: () => void
}) => {
  function loadAll(): void {
    if (onLoadAll) {
      onLoadAll();
    }
  }

  return (
    <div style={{cursor: 'pointer', ...style}}>
      <Flyout trigger={'click'}
              offset={{mainAxis: 20, crossAxis: 0}}
              placement={flyoutPlacement ?? Flyout.PLACEMENTS.BOTTOM}
              content={content ??
                <div>
                  <p>Not all items are currently shown. Either "Load more" for
                    another {pageSize == null ? 'page of items' : `${pageSize} items`}, or "<LinkButton
                      onClick={loadAll}>Load all</LinkButton>" to see everything.</p>
                  <p>Please note that "Load all" may take some time, depending on the number of items.</p>
                  <p>Also note that sorting, searching, and filtering only works on the items you have loaded.</p>
                </div>
              }>
        <AlertWarningIcon style={{color: Theme.colors.yellowOrange500, verticalAlign: 'middle'}}/>
      </Flyout>
    </div>
  );
};

export default WarningPopover;